import { createContext, useContext, useState } from "react";
import { CareerApplicationDrawer } from "@/components/CareerApplicationDrawer";
import type Job from "@/types/jobs";

type CareerApplicationContextType = {
  isOpen: boolean;
  jobTitle?: string;
  selectedJob?: Job;
  openDrawer: (jobTitle?: string) => void;
  closeDrawer: () => void;
  setSelectedJob: (job: Job) => void;
};

const CareerApplicationContext = createContext<CareerApplicationContextType | null>(null);

export function CareerApplicationProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [jobTitle, setJobTitle] = useState<string | undefined>();
  const [selectedJob, setSelectedJob] = useState<Job | undefined>();

  const openDrawer = (title?: string) => {
    setJobTitle(title);
    setIsOpen(true);
  };

  const closeDrawer = () => {
    setIsOpen(false);
  };

  return (
    <CareerApplicationContext.Provider 
      value={{ 
        isOpen, 
        jobTitle, 
        selectedJob, 
        openDrawer, 
        closeDrawer, 
        setSelectedJob 
      }}
    >
      {children}
      <CareerApplicationDrawer isOpen={isOpen} onClose={closeDrawer} jobTitle={jobTitle} />
    </CareerApplicationContext.Provider>
  );
}

export const useCareerApplication = () => {
  const context = useContext(CareerApplicationContext);
  if (!context) {
    throw new Error(
      "useCareerApplication must be used within a CareerApplicationProvider"
    );
  }
  return context;
};
